/*
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-29 18:44:15
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-29 15:51:14
 * @FilePath: /gamefi/utils/string.ts
 */
import Big from 'big.js'

export const limitMaxNumberCoinCount = (value: number, isTwoDifits = false) => {
    const number = Number(value);
    if (isTwoDifits && number.toString().length < 9) {
        return number.toFixed(2);
    }
    return number.toFixed(6);
};

// ↓ 数值转字符，保留8位小数
export const tralingEightDigits = (
    value: number,
    index: number = 8,
): string => {
    const formattedNumber = value.toPrecision(index + 1);
    const sValue = formattedNumber.includes('e') || formattedNumber.length > index + 1;
    return (
        sValue
        ? Number(formattedNumber).toFixed(index).slice(0, index + 2)
        : formattedNumber
    );
};

// ↓ 去除字符尾部多余的 0， 示例如下
// console.log(('1.0').replace(/(?:\.0*|(\.\d+?)0+)$/, '$1')); // 1
// console.log(('1.12300').replace(/(?:\.0*|(\.\d+?)0+)$/, '$1')); // 1.23
export const removeTrailingZeros = (numberStr: string) => {
    let numString = numberStr;
    numString = numString.replace(/(?:\.0*|(\.\d+?)0+)$/, '$1');
    
    return numString;
};

// ↓ 去除小数尾部的0（可最低保留x位小数）例如 1.0000 => 1.00
// ↓ 把短数拉长补0，亦可长数剪短去除尾部的0 
export const trimRightZero = (
    sNumber: string, 
    minDecimals: number = 2,
):string => {
    if (!sNumber.includes('.')) {
        const sTail = (
            minDecimals > 0 ? '.' + '0'.repeat(minDecimals) : ''
        );
        return sNumber + sTail;
    }
    let [intPart, decimalPart] = sNumber.split('.');
    // 移除多余的零
    decimalPart = decimalPart.replace(/0+$/, '');
    // 如果小数部分长度小于最小小数位数，补零
    if (decimalPart.length < minDecimals) {
        decimalPart = decimalPart.padEnd(minDecimals, '0');
    }
    // 如果小数部分为空且不需要保留小数位，则只返回整数部分
    if (decimalPart.length === 0 && minDecimals === 0) {
        return intPart;
    }
    return intPart + '.' + decimalPart;
}


// ↓ 用于向数字尾部追加若干个 0， 以使总长度达到 9️⃣
// ↓ 例如：123 => 123.000000
// ↓ 例如：123456 => 123456.000
export const padEndByZero = (
    iValue: number|string,
    iTotalLong=9, // ← 原版在处理下注金额时的目标长度是9（原版效果：123.456000）
) => {
    iValue = Number(iValue || 0);
    const sValue = iValue.toFixed(10);
    const [sHead] = sValue.split('.');
    // ↓ 仅整数部分就已经达到目标位数
    if (sHead.length >= iTotalLong) {
        return sHead; // 把小数部分剪掉了
    }
    // ↓ 如果整数部分有 4 位，小数部分再补 5 位即可凑齐目标位数 
    let iLong = iTotalLong - sHead.length;
    const sFinalValue = getFixed(iValue, iLong);
    return sFinalValue;
}


// 分割数字的实数与虚数（补位的0）
// 示例：123.000 => ['123', '.000']
// 示例：123.400 => ['123.4', '00']
export const splitNumber = (
    value: number,
    toFixed?: number,
): string[] => {
    if (!value){
        return ['', (0).toFixed(toFixed || 8)];
    }
    let sNumber = (
        toFixed > 0
        ? value.toFixed(toFixed) // 指定小数位数
        : padEndByZero(value) // 在尾部补0，凑足长度  12.34 => 12.3400000
    );
    let sPartTwo = sNumber.match(/\.{0,1}0+$/)?.[0]; 
    if (!sPartTwo){
        return [sNumber, ''];
    }
    const arr = [
        sNumber.slice(0, sNumber.length - sPartTwo.length),
        sPartTwo,
    ]
    return arr;
};


export const countTrailingZeros = (numberStr: string) => {
    let numString = numberStr;

    let match = numString.match(/0+$/);
    const zeroCount = match ? match[0].length : 0;
    const zeroNumberCount = Array.from({ length: zeroCount })
        .map((x) => '0')
        .join('');
    return zeroNumberCount;
};

// ↓ 以“下退” 方式修剪小数位数 💥 全舍不入
// ↓ 此方法用于顶替： Number.toFixed(2) 以防止发生四舍五入，特别是五入
// ↓ 因为在 “严肃场合” 使用 Number.toFixed()会导致用户余额 1.999 转为 2.00，此时下注会报错，服务器会提示你没有那么多钱（2元） 
export const getFixed = (
    amount: number|string,
    iTailLong = 2, // 默认2位小数
) => {
    amount = Number(amount || 0);
    const sStringNumber = amount.toFixed(10);
    let sResult = sStringNumber;
    const [sHead, sTail=''] = sStringNumber.split('.');
    if ((iTailLong || 0) <= 0){
        return sHead;
    }
    if (sTail.length > iTailLong) {
        // ↓ 减掉尾部小数
        sResult = `${sHead}.${sTail.slice(0, iTailLong)}`;
    }else if (sTail.length < iTailLong){
        // ↓ 增加尾部小数
        if (!sTail) sResult += '.';
        sResult += '0'.repeat(iTailLong - sTail.length);
    }
    return sResult;
};

// 数字添加分隔符：
// 示例：123456789 => '123,456,789.00'
export const number2LocaleString = (
    number,
    decimal?: object|number, // 保留小数位数控制  
) => {
    const fNumber = Number(number);
    const option = (()=>{
        decimal ??= 2; // 默认保留2位小数 
        if (typeof decimal === 'object'){
            return decimal;
        }
        return {
            maximumFractionDigits: decimal,
            minimumFractionDigits: decimal,
        }
    })();
    const sResult = fNumber.toLocaleString(void 0, option);
    return sResult;
}

export function minus(a, b) {
    return Big(String(a)).minus(String(b)).toNumber();
}
